import { IHomepageQueryResponse, IQuery } from '@/types';
import { decodeAuthToken, employeeExperienceAxiosInstance } from '@/utils';

export const homePageQuery = ({
  xPlumToken,
}: {
  xPlumToken: string;
}): IQuery<IHomepageQueryResponse> => ({
  queryKey: ['homepage'],
  queryFn: async () => {
    const decodedAuthToken = decodeAuthToken(xPlumToken);
    const { organisationId, memberId } = decodedAuthToken || {};
    return (
      await employeeExperienceAxiosInstance.get(
        `organisations/${organisationId}/member/${memberId}/helpdesk/home`,
      )
    ).data;
  },
});
